import styled from "styled-components";

export const LineChartWrapper = styled.div`
  border-radius: 16px;
  border: 2px solid #f0f0f0;
  padding: 20px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  max-width: ${(props) => props.maxWidth};
  margin: ${(props) => props.margin};
  margin: 0 auto;
  .childContent {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .right {
    text-align: right;
  }
  .chart-section {
    width: 100%;
    height: 250px;
  }
`;
export const Title = styled.h3`
  color: #142c1f;
  margin: 0 0 16px;
  font-size: 16px;
  text-align: left;
`;
export const KalTitle = styled.h3`
  color: #2ecf96;
  font-size: 18px;
`;
export const Description = styled.p`
  color: #44554c;
  font-size: 11px;
  margin: 0;
`;

export const DayTypeFilters = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px; // Increased gap for better spacing
  margin-top: 15px;
  padding: 10px 0;
`;

export const DayTypeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${(props) => (props.active ? "#F5F5F5" : "transparent")};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  color: #2ecf96;

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;
